import BaseClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkContentEditApi extends BaseClient {
  public doExternalLinkContentEdit (id: string, data: any, fileName: string) {
    const path: string = '/v1/external-link-contents/' + id
    const formData = new FormData()
    formData.append('content_name', data.content_name)
    formData.append('record_date', data.record_date)
    formData.append('remarks', data.remarks)
    formData.append('time_stamp', data.time_stamp)

    if (data.file !== undefined && data.file !== '') {
      formData.append('content_file', data.file, fileName)
    }
    if (data.url !== undefined && data.url !== '') {
      formData.append('content_url', data.url)
    }

    /* 共通処理 */
    return super.donotUseContentType().setBody(formData).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new ExternalLinkContentEditApi()
